import React from "react";

const VARIANTS = {
  primary: "bg-ink-800 text-white hover:bg-ink-900 focus-visible:ring-ink-700 shadow-sm",
  accent: "bg-blue-700 text-white hover:bg-blue-800 focus-visible:ring-blue-600 shadow-sm",
  secondary: "bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 focus-visible:ring-slate-400",
  ghost: "bg-transparent text-slate-600 hover:bg-slate-100 focus-visible:ring-slate-400",
  danger: "bg-white text-rose-600 border border-rose-200 hover:bg-rose-50 focus-visible:ring-rose-500",
  success: "bg-emerald-600 text-white hover:bg-emerald-700 focus-visible:ring-emerald-500 shadow-sm",
};

const SIZES = {
  sm: "px-3 py-1.5 text-xs gap-1.5",
  md: "px-4 py-2 text-sm gap-2",
  lg: "px-5 py-2.5 text-sm gap-2",
};

/**
 * Shared button used across the app so every screen gets the same set of
 * enterprise-style actions instead of one-off gradient buttons.
 */
const Button = React.forwardRef(function Button(
  { variant = "primary", size = "md", className = "", as: Comp = "button", icon: Icon, iconPosition = "left", children, ...props },
  ref
) {
  return (
    <Comp
      ref={ref}
      className={`inline-flex items-center justify-center font-medium rounded-md transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...props}
    >
      {Icon && iconPosition === "left" && <Icon size={size === "sm" ? 14 : 16} />}
      {children}
      {Icon && iconPosition === "right" && <Icon size={size === "sm" ? 14 : 16} />}
    </Comp>
  );
});

export default Button;
